module.exports = __webpack_public_path__ + "static/media/klaster-vincenc-500-750.a5238b98.jpg";